import { textareaField } from '../../../utils/field-config-helpers';

export const advancedFieldsConfig = {
  additionalRequirements: textareaField(),
};

export type AdvancedFieldsConfigTypes = typeof advancedFieldsConfig;
